var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCurlyArrowUp = function SvgCurlyArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.343 11.828c-6.769.514-13.247.085-23.588 12.45C14.238 37.228 7.753 36.818.99 37.328",
    stroke: "#333",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m42.553 4.786 6.438 7.063-6.438 7.064",
    stroke: "#333",
    strokeWidth: 2
  })));
};

export { SvgCurlyArrowUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA1MSA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ4LjM0MjYgMTEuODI3NUM0MS41NzQ0IDEyLjM0MiAzNS4wOTU2IDExLjkxMjkgMjQuNzU1IDI0LjI3NzdDMTQuMjM3NiAzNy4yMjc5IDcuNzUyNzUgMzYuODE4OSAwLjk5MDQ4NCAzNy4zMjg4IiBzdHJva2U9IiMzMzMzMzMiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik00Mi41NTI3IDQuNzg1NjRMNDguOTkwNSAxMS44NDkxTDQyLjU1MjcgMTguOTEyNSIgc3Ryb2tlPSIjMzMzMzMzIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";